import React, { ReactNode } from 'react';

interface LegalLayoutProps {
  children: ReactNode;
}

const LegalLayout: React.FC<LegalLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white py-12 page-top-spacing">
      {children}
    </div>
  );
};

export default LegalLayout;